import Vue from "vue";

const state = {
  shipmentProfileRate: {
    name: "",
    cost: "",
    minPrice: "",
    maxPrice: "",
    minWeight: "",
    maxWeight: ""
  },
  shipmentProfileRates: []
};

const getters = {};

const actions = {
  DESTROY_SHIPMENT_PROFILE_RATE: async function({ dispatch }, payload) {
    await Vue.prototype.$axios.delete(
      "/shipments/profiles/" +
        payload.shipmentProfileId +
        "/rate/" +
        payload.shipmentProfileRateId
    );
    dispatch("LOAD_SHIPMENT_PROFILE_RATES", payload);
  },
  LOAD_SHIPMENT_PROFILE_RATES: async function({ commit }, payload) {
    await Vue.prototype.$axios
      .get("/shipments/profiles/" + payload.shipmentProfileId + "/rates")
      .then(res => {
        commit("SET_SHIPMENT_PROFILE_RATES", res.data.shipmentProfileRates);
      });
  },
  CREATE_SHIPMENT_PROFILE_RATE: async function({ commit, dispatch }, payload) {
    await Vue.prototype.$axios.post(
      "/shipments/profiles/" + payload.id + "/rate",
      payload.shipmentProfileRate
    );
    dispatch("LOAD_SHIPMENT_PROFILE_RATES", {
      shipmentProfileId: payload.id
    });
    commit("SET_EMPTY_SHIPMENT_PROFILE_RATE");
  }
};

const mutations = {
  SET_EMPTY_SHIPMENT_PROFILE_RATE: function(state, payload) {
    state.shipmentProfileRate.name = "";
    state.shipmentProfileRate.cost = "";
    state.shipmentProfileRate.minPrice = "";
    state.shipmentProfileRate.maxPrice = "";
    state.shipmentProfileRate.minWeight = "";
    state.shipmentProfileRate.maxWeight = "";
  },
  SET_SHIPMENT_PROFILE_RATES: function(state, payload) {
    state.shipmentProfileRates = payload;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
